import React, { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useDataLastServices from '../../hooks/useDataLastServices'; // Assuming you have a similar hook
import URLS from '../../enums/route';
import Draggable from 'react-draggable';
import { Box, Paper, Typography } from '@mui/material';
import { ServiceStatus } from '../../enums/serviceStatus';

const DRAG_THRESHOLD = 10; // Movement threshold to differentiate between click and drag

const ServicesDraggable: React.FC = () => {
    const [openServices, setOpenServices] = useState<boolean>(false);
    const { pathname } = useLocation();
    const { data: services } = useDataLastServices(true); 
    const navigate = useNavigate();
    const [isDragging, setIsDragging] = useState<boolean>(false);

    const startPosition = useRef<{ x: number; y: number } | null>(null);

    const handlePointerDown = (event: React.PointerEvent) => {
        setIsDragging(false);
        startPosition.current = { x: event.clientX, y: event.clientY };
    };

    const handlePointerMove = (event: React.PointerEvent) => {
        if (startPosition.current) {
            const dx = Math.abs(event.clientX - startPosition.current.x);
            const dy = Math.abs(event.clientY - startPosition.current.y);
            if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
                setIsDragging(true);
            }
        }
    };

    const handlePointerUp = (item?: { documentNumber: string }) => {
        if (!isDragging) {
            if (item) {
                navigate(`${URLS.SERVICE_DOCUMENT_PAGE.LINK}/${item.documentNumber}`);
            } else {
                setOpenServices(!openServices);
            }
        }
        setIsDragging(false);
        startPosition.current = null;
    };

    return (
        <>
            {(pathname.includes(URLS.SERVICE.LINK) || pathname.includes(URLS.MACHINE_PAGE.LINK)) &&
                <>
                    {services && services.length > 0 &&
                        <>
                            {!openServices && services.length > 8 ?
                                <Draggable>
                                    <Paper
                                        onPointerDown={handlePointerDown}
                                        onPointerMove={handlePointerMove}
                                        onPointerUp={() => handlePointerUp()}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '70px',
                                            height: '70px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #00bcd4, #009688)',
                                            color: 'white',
                                            position: 'relative',
                                            boxShadow: 3,
                                            border: '2px solid white'
                                        }}
                                    >
                                        <img src={`${process.env.REACT_APP_MEDIA}/repair.svg`} alt="icon" width={'35px'} height={'35px'} />
                                        <Typography fontSize={'10px'} fontWeight={700} lineHeight={'8px'} textAlign={'center'}>
                                            {`${services.length}`}
                                        </Typography>
                                        <Typography fontSize={'10px'} fontWeight={700} lineHeight={'8px'} textAlign={'center'}>
                                            {'קריאות פתוחות'}
                                        </Typography>
                                    </Paper>
                                </Draggable>
                                :
                                (openServices || services.length < 8) && services.map((item) => 
                                    <Draggable key={item.documentNumber}>
                                        <Paper
                                            onPointerDown={handlePointerDown}
                                            onPointerMove={handlePointerMove}
                                            onPointerUp={() => handlePointerUp(item)}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '70px',
                                                height: '70px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #00bcd4, #009688)',
                                                color: 'white',
                                                position: 'relative',
                                                boxShadow: 3,
                                                border: '2px solid white'
                                            }}
                                        >
                                            <img src={`${process.env.REACT_APP_MEDIA}/${item.status === ServiceStatus.Final ? 'completeRepair' : 'repair'}.svg`} alt="icon" width={'35px'} height={'35px'} />
                                            <Typography fontSize={'10px'} fontWeight={700} lineHeight={'8px'} textAlign={'center'}>
                                                {`קריאה`}
                                            </Typography>
                                            <Typography fontSize={'10px'} fontWeight={700} lineHeight={'8px'} textAlign={'center'}>
                                                {item.documentNumber.slice(-4)}
                                            </Typography>
                                        </Paper>
                                    </Draggable>
                                )
                            }
                        </>
                    }
                </>
            }
        </>
    );
};

export default ServicesDraggable;
